import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import useApiUrls from "../../useApiUrls";

const UpdateThirdPartyHtml = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { getUrlByOperation } = useApiUrls();

  const [formData, setFormData] = useState({
    id: id,
    name: "",
    url: "",
    remark: "",
    active: true
  });

  const [initialLoading, setInitialLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [loading, setLoading] = useState(false);

  const token = getCookie("token") || getCookie("authToken") || "";
  const userid = getCookie("userid") || getCookie("userId") || "1";

  const getHeaders = () => ({
    "accept": "text/plain",
    "UserId": userid,
    "X-Authorization": token,
    "Content-Type": "application/json-patch+json"
  });

  // Fetch record data by ID
  useEffect(() => {
    const fetchRecord = async () => {
      setInitialLoading(true);
      try {
        const getUrl = getUrlByOperation("ThirdPartyHtmlGet") || "https://api.dqr-display-tms.bonrix.in/api/ThirdPartyHtmlOperation/Get";
        const response = await axios.post(
          getUrl,
          { id: parseInt(id), name: "" },
          { headers: getHeaders() }
        );

        if (response.data && response.data.isresponse && Array.isArray(response.data.data) && response.data.data.length > 0) {
          const detail = response.data.data[0];
          setFormData({
            id: detail.id || id,
            name: detail.name || detail.Firmwarename || "",
            url: detail.url || "",
            remark: detail.remark || "",
            active: detail.active !== undefined ? detail.active : true
          });
        } else if (response.data && response.data.data && !Array.isArray(response.data.data)) {
          const detail = response.data.data;
          setFormData({
            id: detail.id || id,
            name: detail.name || "",
            url: detail.url || "",
            remark: detail.remark || "",
            active: detail.active !== undefined ? detail.active : true
          });
        } else {
          // Fallback search
          const searchUrl = getUrlByOperation("ThirdPartyHtmlSearch") || "https://api.dqr-display-tms.bonrix.in/api/ThirdPartyHtmlOperation/Search";
          const searchRes = await axios.post(
            searchUrl,
            {
              id: parseInt(id),
              createdip: "",
              modifiedip: "",
              applycreateddate: false,
              applymodifieddate: false,
              fromcreateddate: 0,
              endcreateddate: 0,
              frommodifieddate: 0,
              endmodifieddate: 0,
              active: "",
              name: "",
              ispageload: false,
              pagesize: 10,
              currentpageno: 0,
              withoutpagination: true,
              pagedirection: ""
            },
            { headers: getHeaders() }
          );
          if (searchRes.data && Array.isArray(searchRes.data.data)) {
            const found = searchRes.data.data.find((item) => String(item.id) === String(id));
            if (found) {
              setFormData({
                id: found.id,
                name: found.name || "",
                url: found.url || "",
                remark: found.remark || "",
                active: found.active !== undefined ? found.active : true
              });
            }
          }
        }
      } catch (error) {
        console.error("Error fetching record details:", error);
        setMessage("Failed to load details for this item");
        setMessageType("danger");
      } finally {
        setInitialLoading(false);
      }
    };

    if (id) {
      fetchRecord();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, getUrlByOperation, token, userid]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value === "true" ? true : value === "false" ? false : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.url.trim()) {
      setMessage("Please enter a URL");
      setMessageType("danger");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const updateUrl = getUrlByOperation("ThirdPartyHtmlUpdate") || "https://api.dqr-display-tms.bonrix.in/api/ThirdPartyHtmlOperation/Update";
      const payload = {
        id: parseInt(formData.id),
        name: formData.name,
        url: formData.url,
        remark: formData.remark,
        active: Boolean(formData.active)
      };

      const response = await axios.post(
        updateUrl,
        payload,
        { headers: getHeaders() }
      );

      if (response.data && (response.data.isresponse || response.data.responsestatus === "SUCCESS")) {
        setMessage("Third Party HTML updated successfully!");
        setMessageType("success");
        setTimeout(() => {
          navigate("/thirdparty-html");
        }, 1500);
      } else {
        setMessage(response.data?.errormsg || "Failed to update Third Party HTML");
        setMessageType("danger");
      }
    } catch (error) {
      console.error("Error updating Third Party HTML:", error);
      setMessage(error.response?.data?.errormsg || error.message || "Failed to update Third Party HTML");
      setMessageType("danger");
      if (error.message === "relogin token expire" || error.response?.status === 401) {
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center">
                <h1>Update Third Party HTML</h1>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/thirdparty-html")}
                >
                  <i className="fas fa-arrow-left mr-1"></i> Back to List
                </button>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Edit Entry #{id}</h3>
                    </div>
                    <div className="card-body">
                      {initialLoading ? (
                        <div className="text-center py-5">
                          <div className="spinner-border text-info" role="status">
                            <span className="sr-only">Loading record...</span>
                          </div>
                        </div>
                      ) : (
                        <form onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>ID</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={formData.id}
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  value={formData.name}
                                  onChange={handleChange}
                                  placeholder="Enter name"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>URL *</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="url"
                                  value={formData.url}
                                  onChange={handleChange}
                                  placeholder="https://example.com/widget"
                                  required
                                />
                              </div>
                            </div>

                            <div className="col-sm-6">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  name="active"
                                  value={formData.active}
                                  onChange={handleChange}
                                >
                                  <option value={true}>Active</option>
                                  <option value={false}>Inactive</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label>Remark</label>
                                <textarea
                                  className="form-control"
                                  name="remark"
                                  value={formData.remark}
                                  onChange={handleChange}
                                  placeholder="Enter remark or description"
                                  rows={3}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="form-footer mt-3">
                            <button
                              type="submit"
                              className="btn btn-info mr-2"
                              disabled={loading}
                            >
                              {loading ? (
                                <>
                                  <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                  Updating...
                                </>
                              ) : (
                                "Update Third Party HTML"
                              )}
                            </button>
                            <button
                              type="button"
                              className="btn btn-default"
                              onClick={() => navigate("/thirdparty-html")}
                            >
                              Cancel
                            </button>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && (
        <div style={{ position: "fixed", top: "20px", right: "20px", width: "300px", zIndex: "9999" }}>
          <div className={`alert alert-${messageType} alert-dismissible fade show`} role="alert">
            {message}
            <button type="button" className="close" onClick={() => setMessage("")}>
              <span>&times;</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateThirdPartyHtml;

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}
